/* unplugin-vue-components disabled */import script from "./GraphicalReasoningRender.vue?vue&type=script&setup=true&lang=js"
export * from "./GraphicalReasoningRender.vue?vue&type=script&setup=true&lang=js"

import "./GraphicalReasoningRender.vue?vue&type=style&index=0&id=4d156662&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d156662"]])

export default __exports__